import { MaskedInput } from 'antd-mask-input';
import { MaskedInputProps } from 'antd-mask-input/build/main/lib/MaskedInput';

export const InputMask = (props: MaskedInputProps) => {
  return <MaskedInput maskOptions={{ lazy: true }} {...props} />;
};
